import React from "react";

import PayoutsList from "PayoutsList";

// Venue admin payout index — read-only, scoped to the venue's own payouts.
// Venue admins cannot create payouts (those are issued from internal tools).
// No search box — a venue only ever sees its own handful of payouts, so there
// is nothing meaningful to search for.
const PayoutList = () => (
  <PayoutsList endpoint="venue_admin/payouts" canCreate={false} searchable={false} />
);

export default PayoutList;
